var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOrganizationActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.027,
    x2: 1,
    y2: 0.91,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d0b77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5fa2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_305",
    "data-name": "Subtraction 305",
    d: "M-3.7,20H-22.3a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7h.7V6a1,1,0,0,1,1-1H-17V2a2,2,0,0,1,2-2h4A2,2,0,0,1-9,2V5h3.6a1,1,0,0,1,1,1V18.6h.7a.7.7,0,0,1,.7.7A.7.7,0,0,1-3.7,20ZM-13,15.2a.7.7,0,0,0-.7.7v2.7h1.4l0-2.7A.7.7,0,0,0-13,15.2Zm4-3.4v1.4h1.3a.7.7,0,0,0,.7-.7.7.7,0,0,0-.7-.7Zm-5.3,0a.7.7,0,0,0-.7.7.7.7,0,0,0,.7.7h2.6a.7.7,0,0,0,.7-.7.7.7,0,0,0-.7-.7Zm-4,0a.7.7,0,0,0-.7.7.7.7,0,0,0,.7.7H-17l0-1.4ZM-9,8.4V9.8h1.3A.7.7,0,0,0-7,9.1a.7.7,0,0,0-.7-.7Zm-9.3,0a.7.7,0,0,0-.7.7.7.7,0,0,0,.7.7H-17l0-1.4Zm4,0a.7.7,0,0,0-.7.7.7.7,0,0,0,.7.7h2.6a.7.7,0,0,0,.7-.7.7.7,0,0,0-.7-.7Zm0-3.4a.7.7,0,0,0-.7.7.7.7,0,0,0,.7.7h2.6a.7.7,0,0,0,.7-.7.7.7,0,0,0-.7-.7Z",
    transform: "translate(23)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrganizationActive);
export default __webpack_public_path__ + "static/media/icon-organization-active.f5652f46a07125b89258267994965dcb.svg";
export { ForwardRef as ReactComponent };